export default {
  BusinessStockDistributionPlanView: {
    title: '基础信息',
    code: '计划单号',
    receiveWarehouseId: '接收仓',
    selectTime: '请先选择开始时间',
    priority: '优先级',
    commodityDetails: '商品明细',
    addingGoods: '添加商品',
    delGoods: '删除商品',
    text: '接收仓为数量虚仓且有缺货的时候显示',
    backorderAllocation: '缺货订单分配',
    receiveWarehouseText: '请选择接收仓',
    startDateText: '请选择开始日期',
    priorityGrade: '请输入优先级',
    msgSuccess: '删除成功',
    msgWarning: '计划供应数量不能小于1',
    confirmText1: '是否审核',
    confirmText2: '通过',
    confirmText3: '不通过',
    confirmText4: '该数据？',
    confirmText5: '是否确定批量删除选中的数据?',

    table: {
      inStockNum: '接收仓在库库存',
      inStockUsableNum: '接收仓可用库存',
      stockOutNum: '接收仓缺货数量',
      planNum: '计划供应数量',
      priorityReplenishStatus: '是否优先补缺货订单'
    },
  }
};
